/**
 * `shopify-payment-terms` (Shop Pay installments) renders its copy inside a closed shadow tree.
 * Global theme CSS cannot reach #shopify-installments-content; inject rules that use brand CSS variables.
 */
(function () {
  const STYLE_ID = "fc-payment-terms-font-style";
  const processed = new WeakSet();

  function inject(shadow) {
    if (!shadow || shadow.getElementById(STYLE_ID)) {
      return;
    }
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      :host {
        font-family: var(--text-font-family) !important;
        font-style: var(--text-font-style) !important;
      }
      #shopify-installments-content,
      #shopify-installments-content * {
        font-family: var(--text-font-family) !important;
        font-style: var(--text-font-style) !important;
      }
    `;
    shadow.appendChild(style);
  }

  function watchShadow(el, shadow) {
    inject(shadow);
    new MutationObserver(() => {
      queueMicrotask(() => inject(el.shadowRoot));
    }).observe(shadow, { childList: true, subtree: true });
  }

  function process(el) {
    if (!(el instanceof HTMLElement) || el.tagName !== "SHOPIFY-PAYMENT-TERMS") {
      return;
    }
    if (processed.has(el)) {
      return;
    }
    if (el.shadowRoot) {
      processed.add(el);
      watchShadow(el, el.shadowRoot);
      return;
    }
    processed.add(el);
    let attempts = 0;
    const id = window.setInterval(() => {
      attempts += 1;
      if (el.shadowRoot) {
        window.clearInterval(id);
        watchShadow(el, el.shadowRoot);
      } else if (attempts > 60) {
        window.clearInterval(id);
      }
    }, 25);
  }

  function scan(root) {
    root.querySelectorAll("shopify-payment-terms").forEach(process);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scan(document));
  } else {
    scan(document);
  }

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.("shopify-payment-terms")) process(node);
        else node.querySelectorAll?.("shopify-payment-terms").forEach(process);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
